import {
    setTrackIsLoading, 
    setEffectParameterValues
} from 'actions/index.js';

export default superclass => class extends superclass  {
    setupFM() {
        let track = this.track;
        this.oscillators[0].track = track;
        this.oscillators[0].x = 83;
        this.oscillators[0].y = 40;
        this.oscillators[1].track = track;
        this.oscillators[1].x = 26;
        this.oscillators[1].y = 40;
        this.oscillators[3].track = track;
        this.oscillators[3].x = 26;
        this.oscillators[3].y = 80;
        this.oscillators[2].track = track;
        this.oscillators[2].x = 83;
        this.oscillators[2].y = 80;

        this.carrier = this.oscillators[0];
        this.oscillators
            .forEach(
                osc => osc === this.carrier ?
                    osc.fm(undefined, false) :
                    osc.fm(this.carrier, false));

       let bulk = this.oscillators.reduce(
            (a,b) => ({... a, ... b.bulk}), {});

        this.sequencerEngine.dispatch(
            setEffectParameterValues(bulk));
  
        this.oscillators[0].ampEnvelope = this.ampEnvelope;

        this.oscillators[0].harmonicityParameter.set(0.5);
        this.oscillators[1].harmonicityParameter.set(1);
        this.oscillators[2].harmonicityParameter.set(2);
        this.oscillators[3].harmonicityParameter.set(4);

        this.carrier = this.oscillators[0];
        // this.oscillators[0].carrier = this.carrier;
        this.oscillators[1].carrier = this.carrier;
        this.oscillators[2].carrier = this.carrier;
        this.oscillators[3].carrier = this.carrier;

    }
}
